"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ethTeleswapToken = void 0;
exports.ethTeleswapToken = "0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE";
//# sourceMappingURL=teleport-tokens.js.map